
import { Component, Vue, Watch } from 'vue-property-decorator';
import CameraChildIntroductionNormal from '@/pages/camera/CameraChildIntroductionNormal.vue';
import CameraChildIntroductionGpdoc from '@/pages/camera/CameraChildIntroductionGpdoc.vue';
import CameraChildIntroductionOpdoc from '@/pages/camera/CameraChildIntroductionOpdoc.vue';
import CameraChildIntroductionPassVaccine from '@/pages/camera/CameraChildIntroductionPassVaccine.vue';

@Component({
  components: {
    CameraChildIntroductionNormal,
    CameraChildIntroductionGpdoc,
    CameraChildIntroductionOpdoc,
    CameraChildIntroductionPassVaccine
  }
})
export default class Page extends Vue {
  private get isGpDocPage(): boolean {
    return this.$store.getters['camera/isGpdoc'];
  }

  private get isOpDocPage(): boolean {
    return this.$store.getters['camera/isOpdoc'];
  }

  private get isPassVaccine(): boolean {
    return this.$store.getters['auth/isPassVaccine'];
  }

  public async created(): Promise<void> {
    // 撮影トリガーを戻す
    this.$store.commit('camera/isShooted', false);
    this.$store.commit('camera/isDetectSuccess', false);
    // ページマウント時の設定
    await this.$store.dispatch('camera/mountedSetting', this.$route.path);
  }

  private async onStart(): Promise<void> {
    await this.$store.dispatch('sensorMotion/setup');
    this.$store.commit('camera/isStart', true);
    this.$router.push(this.$store.getters['camera/locationShoot']);
  }

  @Watch('$i18n.locale')
  private async onLocaleChanged(locale: string): Promise<void> {
    await this.$store.dispatch('camera/mountedSetting', this.$route.path);
  }
}
